<template>
	<div class="container">
		<div class="list" v-for='(val,key) in quality' :key='key'>
			<div class="text"  v-if="$i18n.locale == 'zh'">
				{{val.title}}
			</div>
			<div class="text" v-else-if="$i18n.locale == 'en'">
				{{val.y_title}}
			</div>
			<div class="text" v-else>
				{{val.e_title}}
			</div>


			<p v-if="$i18n.locale == 'zh'">{{val.desc}}</p>
			<p v-else-if="$i18n.locale == 'en'">{{val.y_desc}}</p>
			<p v-else>{{val.e_desc}}</p>
		</div>
		<!-- <div class="list">
			<div class="text">
				恪守严苛的质量标准，建立缜密的质量思维，塑造良好的质量文化
			</div>
			<p>我们以质量文化理念为导向，包括严格的质量标准和缜密的质量思维，助力客户创新药在全球95多个国家和地区获批上市，成为中国药品上市许可持有人制度（MAH）试点开展以来首个支持获批创新药的受托企业。</p>
		</div>
		<div class="list">
			<div class="text">
				努力帮助客户成功
			</div>
			<p>我们致力帮助客户快速将产品推向市场，以减轻病患的痛苦，努力提高人们生活质量。</p>
		</div>
		<div class="list">
			<div class="text">
				良好的法规审计记录
			</div>
			<p>2011年以来，公司先后10次顺利通过美国FDA检查(2011，2014，2015，2017, 2018，2019)，2次澳大利亚TGA(2015,
				2017)，一次韩国MFDS(2017)，以及20多次中国NMPA检查，全部顺利通过。
				从2015年以来已经通过了近300多次客户的cGMP审计。
			</p>
		</div> -->
		<!-- <div class="image">
			<el-image src="./static/image/head1.png" fit="fill"></el-image>
			<el-image src="./static/image/head1.png" fit="fill"></el-image>
			<el-image src="./static/image/head1.png" fit="fill"></el-image>
		</div> -->
	</div>
</template>

<script>
	export default {
		data() {
			return {
				quality:[],
			}
		},
		mounted() {
			this.getabout()
		},
		methods: {
			getabout() {
				var that = this;
				this.$axios
					.post("/api/index/quality", {
					})
					.then(function (ret) {
						if (ret.data.code == 0) {
							that.quality = ret.data.data.quality;
						} else {
							that.$fail(ret.data.msg);
						}
					}
				);
			},
		}
	}
</script>

<style lang="scss" scoped>
	.container {
		width: 900px;
		display: flex;
		flex-direction: column;

		.list {
			width: 900px;
			min-height: 162px;
			background: #F2F5FA;
			display: flex;
			flex-direction: column;
			margin-bottom: 20px;
			padding: 20px;

			.text {
				font-size: 18px;
				font-weight: bold;
				color: #004098;
				margin-bottom: 16px;
			}

			p {
				font-size: 16px;
				line-height: 30px;
				color: #333333;
			}
		}
		.image{
			width: 900px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			.el-image{
				width: 286px;
				height: 214px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/AboutUs/quality.vue